<template>   
<div class="input-container" :class="num">     <label class="label">{{ label }}</label>     
<el-input autoId="input_selectVal" v-model.trim="selectVal" size="small" :placeholder="placeholder" clearable maxlength="50" />    
</div> </template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: '60px'
    }
  },
  data() {
    return {
      selectVal: this.value,
      num: 'input' + Math.random().toString().split('.')[1]
    }
  },
  watch: {
    value(val) {
      this.selectVal = val
    },
    selectVal(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
    const element = document.querySelector(`.${this.num}`)
    element.style.setProperty('--inputleft', `${this.labelWidth.split('px')[0] * 1 + 12}px`)
    element.style.setProperty('--inputpadding', `${this.labelWidth.split('px')[0] * 1 + 36}px`)
    element.style.setProperty('--inputafter', `${this.labelWidth.split('px')[0] * 1 + 18}px`)
  }
}
</script>
<style lang="scss" scoped>
.input-container {
  --inputleft: 60px;
  --inputpadding: 72px;
  --inputafter: 66px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  line-height: 32px;
}
.label {
  z-index: 1;
  position: absolute;
  margin: 0 12px;
  left: 0;
  height: 32px;
  width: var(--inputleft);
  display: inline-block;
  text-align: center;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  line-height: 32px;
}
:deep(input) {
  flex: 1;
  padding-left: var(--inputpadding);
  height: 32px;
  line-height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  outline: none;
}
input::placeholder {
  //   padding-left: 60px;
  font-size: 14px;
  color: #cccccc;
  letter-spacing: 0;
  line-height: 14px;
  font-weight: 400;
}
</style>
